import { StateNode, ProcessConfig } from '../types';

export function interrupted(options: ProcessConfig): StateNode {
  return {
    entry: ['setStatusInterrupted', 'assignLastModifiedDate', 'save', 'close'],
  };
}
